export const DimensionInputUnit = {
  centimeters: 'centimeters',
  centimeter: 'centimeter',
  inches: 'inches',
  inch: 'inch',
};
